import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center d-flex justify-content-center align-items-center">
            <div className="p-4 m-4" style={{height:"32vh"}}>
                <h1 >404</h1>
                <h2>This page is not Found</h2>
            </div>
            
        </div>
    );
};

export default NotFound;